<template>
  <div>
    <h1>qr test</h1>
    <input v-model="url" size=50><br>
    <input type="checkbox" class="browser-default" v-model="shorten"> Shorten {{shorturl}}<br>

    err:<input v-model="errLevel" size=2>
    scale: <input type=number v-model="scale">
    margin: <input type=number v-model="margin">
    dark: <input type=color v-model="dark">
    light: <input type=color v-model="light"><br>
    <pre>{{JSON.stringify(params, null, 4)}}</pre>
    {{dataUrl.length}} bytes<br>
    <img :src="dataUrl">
    <br>
    {{svg.length}} bytes<br>
    <div v-html="svg"/>
  </div>
</template>
<script>
import QRCode from "qrcode";
import {shortenUrl} from "@/services/shorturl";
export default {
  data() {
    return {
      // Generated data
      dataUrl: '',
      svg: '',
      shorturl: '',

      // Input parameters
      url: 'https://www.brandly.com/',
      shorten: false,
      errLevel: 'M',
      scale: 4,
      margin: 4,
      dark: '#000000',
      light: '#ffffff',

      // shortening process state
      shortenedUrl: '',
      shortening: false,
    }
  },
  mounted() {
    this.generate(this.params);
  },
  computed: {
    params() {
      // While shorturl not setm, return url
      let url = this.shorten && this.shorturl || this.url;
      return {url, options: {
          errorCorrectionLevel: this.errLevel,
          scale: +this.scale,
          margin: +this.margin,
          color: {
            dark: this.dark+'ff',
            light: this.light+'ff'
          }
        }
      }
    }
  },
  methods: {
    async generate({url, options}) {
      this.dataUrl = await QRCode.toDataURL(url, options)
      this.svg = await QRCode.toString(url, options)
    },
    async shortenUrl() {
      if (this.shorten && this.url != this.shortenedUrl) {
        this.shortening = true
        this.shorturl = (await shortenUrl(this.url)).toUpperCase();
        this.shortening = false;
        this.shortenedUrl = this.url;
      }
    }
  },
  watch: {
    params(params) {
      this.generate(params);
    },
    shorten() {
      this.shortenUrl();
    },
    url() {
      this.shortenUrl();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/homepage/Qr.vue